import { useQuery } from '@tanstack/react-query';
import { IDonationGoal } from 'types/src/types';
import { deleteDonationGoal, getDonationGoal } from '@/src/actions/donationGoal';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createDonationGoal,
  updateDonationGoal,
} from '@/src/actions/donationGoal';

export function useDonationGoal(creatorId: number) {
  return useQuery<IDonationGoal | null>({
    queryKey: ['donationGoal', creatorId],
    queryFn: async () => {
      const result = await getDonationGoal(creatorId);
      return result.donationGoal ?? null;
    },
  });
}

export function useDonationGoalMutations(creatorId: number) {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (data: Partial<IDonationGoal>) => createDonationGoal(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['donationGoal', creatorId] });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<IDonationGoal> }) =>
      updateDonationGoal(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['donationGoal', creatorId] });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id: number) => deleteDonationGoal(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['donationGoal', creatorId] });
    },
  });

  return { createMutation, updateMutation, deleteMutation };
}